export const currentDailyChallengeSelector = (state: any) =>
  state.currentDailyChallenge;
